import { Phone } from "lucide-react";

const MobileCallButton = () => {
  return (
    <a
      href="tel:450-441-3636"
      className="mobile-call-btn md:hidden"
      data-testid="mobile-call-floating-button"
      aria-label="Appelez-nous au 450-441-3636"
    >
      <Phone className="w-6 h-6" />
    </a>
  );
};

export default MobileCallButton;
